import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-xs text-left" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col w-70 gap-y-1 text-center"
}
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = { key: 1 }

import { inject, onMounted, ref } from "vue";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { useStore } from "vuex";
import { AxiosInstance } from "axios";
import dayjs from "dayjs";
import "dayjs/locale/th";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopOver',
  props: {
  data: Object,
  title: { type: String, default: "title" },
  manualValue: Object || String,
},
  setup(__props) {

const props = __props



const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const result = ref();
const isLoading = ref(false)

const checkData = async (data: any) => {
  isLoading.value = true
  const payload = {
    operator_id: store.state.selectedOperator.operatorId,
    type: data._useTransfer? data.transferType : data.action
  }
  if(data._useTransfer) payload["transfer_id"] = data.id
  else payload["trx_id"] = data.id
  const value = await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/get_approver_v2`,
      payload
  )
  .then((res) => res.data.result)
  .catch((err) => {console.log(err);})
  result.value = value
  isLoading.value = false

};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_unref(Popover), { class: "relative w-64" }, {
    default: _withCtx(() => [
      _createVNode(_unref(PopoverButton), {
        class: "text-white rounded p-1 w-24 bg-blue-400 border-0",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (checkData(__props.data)))
      }, {
        default: _withCtx(() => [
          (isLoading.value)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                spin: "",
                class: "text-gray-500",
                transform: "grow-6",
                icon: ['fas', 'circle-notch']
              }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(__props.title), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(PopoverPanel), { class: "ring rounded absolute z-10 p-1 bg-white mt-1" }, {
        default: _withCtx(() => [
          (__props.manualValue)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (Array.isArray(__props.manualValue))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.manualValue, (x) => {
                        return (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(x), 1))
                      }), 256))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.manualValue), 1))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (!isLoading.value && result.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, [
                        _createTextVNode(_toDisplayString(_ctx.$t("messages.player.topupWithdrawRecords.approvedBy")) + ": ", 1),
                        _createElementVNode("b", null, _toDisplayString(result.value.approvedBy?result.value.approvedBy: result.value.approve_by?result.value.approve_by:'system'), 1)
                      ]),
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("messages.player.topupWithdrawRecords.slipTime")) + ": " + _toDisplayString(result.value.requested_at?_unref(dayjs)(result.value.requested_at).locale("th").format("LLL"):'-'), 1),
                      _createElementVNode("p", _hoisted_9, " Approved at: " + _toDisplayString(result.value.approveAt? _unref(dayjs)(result.value.approveAt).locale("th").format("LLL") : result.value.approvedAt? _unref(dayjs)(result.value.approvedAt).locale("th").format("LLL"): `-`), 1)
                    ]))
                  : (!isLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("messages.player.topupWithdrawRecords.noArover")), 1)
                      ]))
                    : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})